import { render, staticRenderFns } from "./CardStatisticsVertical.vue?vue&type=template&id=669495ee"
import script from "./CardStatisticsVertical.js?vue&type=script&lang=js&external"
export * from "./CardStatisticsVertical.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports